import { REQUEST_DOS_A} from '../../../const';

export default function DOSAReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_DOS_A:
      return action.dos_a;
    default:
      return state;
  }
}